export default {
    monitor: {name: "Tenere sotto controllo"},
    keyboard: {name: "Tastiera"},
    mouse: {name: "Topo"},
    webcam: {name: "Webcam"},
    headset: {name: "Auricolare"},
    dockingStation: {name: "Stazione di attracco"},
}